import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HXTab } from "./HXTab";
import { observer } from "mobx-react";
import { Outlet } from "react-router";
import { addDisplayName } from "../Infra/display-name";
import { AdminViewParent } from "./AdminView.styles";
import { AdminViewModel } from "./AdminViewModel";
import { GoLiveChecklistView } from "./GoLiveChecklistView";
import { HXPageHeader, HXPageSubtabs, HXPageTitle } from "./HXDesktopPage";
import { useViewModel } from "./useViewModel";
export const AdminView = observer((props) => {
    const model = useViewModel(AdminViewModel, props.container);
    return (_jsxs(AdminViewParent, { children: [_jsx(HXPageHeader, { onBack: model.onBack, children: _jsx(HXPageTitle, { children: model.pageTitle }) }), _jsx(HXPageSubtabs, { value: model.currentAdminPage, onChange: (_event, page) => model.setCurrentAdminPage(page), children: model.adminPagesToShow.map(({ page, label }) => (_jsx(HXTab, { value: page, label: label, analyticsId: label }, page))) }), _jsx(Outlet, {}), !model.organizationIsLive && _jsx(GoLiveChecklistView, { type: "dialog", container: props.container })] }));
});
addDisplayName(AdminView, "AdminView");
